module.exports = __webpack_public_path__ + "media/application/images/2023/stills_1.1.3-0787a4cf9d42f3e1d303c343d88ad49d.png";